import React from 'react';
import { Group, MultiSelect, Select } from '@mantine/core';
import { useSalon } from '../../../../context/SalonContext';
import { useCalendar } from '../../../../context/CalendarContext';

function CalendarFilters({ isMobile }) {
  const { employees, services } = useSalon();
  const { 
    selectedArtists, 
    selectedService, 
    setSelectedArtists, 
    setSelectedService 
  } = useCalendar();

  const handleArtistChange = (values) => {
    // If no values are selected, set empty array
    if (!values.length) {
      setSelectedArtists([]);
      return;
    }

    // If selecting "all"
    if (values.includes('all') && !selectedArtists.includes('all')) {
      setSelectedArtists(['all']);
      return;
    }

    // If "all" was previously selected and selecting another option
    if (selectedArtists.includes('all')) {
      setSelectedArtists([values[values.length - 1]].filter(v => v !== 'all'));
      return;
    }

    // Normal multi-select behavior
    setSelectedArtists(values.filter(v => v !== 'all'));
  };

  const artistData = [
    { value: 'all', label: 'All Artists' },
    ...(employees?.map(emp => ({
      value: emp.id,
      label: `${emp.first_name} ${emp.last_name}`
    })) || [])
  ];

  const selectStyles = (theme) => ({
    input: {
      backgroundColor: 'transparent',
      border: '1px solid #dee2e6',
      borderRadius: '100px',
      minHeight: '36px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    rightSection: {
      right: '12px'
    }
  });

  const selectWidth = isMobile ? { width: 120 } : { width: 150 };

  return (
    <Group spacing="md" align="flex-start">
      <MultiSelect
        data={artistData}
        value={selectedArtists}
        onChange={handleArtistChange}
        placeholder="Select Artists"
        valueComponent={({ value, label, onRemove }) => (
          value === 'all' ? (
            <div>All Artists</div>
          ) : (
            <div>{label}</div>
          )
        )}
        w={isMobile ? 160 : 260}
        radius="sm"
        clearable
        searchable
        styles={(theme) => ({
          input: {
            backgroundColor: 'transparent',
            border: '1px solid #dee2e6',
            minHeight: '36px',
          },
          value: {
            backgroundColor: theme.colors.violet[1],
          },
          defaultValue: {
            backgroundColor: theme.colors.violet[1],
          }
        })}
      />
      <Select
        placeholder="All Types"
        value={selectedService}
        onChange={setSelectedService}
        data={[
          { value: 'all', label: 'All Types' },
          ...(services ? services.map(service => ({
            value: service.id,
            label: service.name
          })) : [])
        ]}
        styles={selectStyles}
        style={selectWidth}
      />
    </Group>
  );
}

export default CalendarFilters; 